const dict = {
  languageName: '简体中文',
  locale: 'zh-CN',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: '主题',
  'theme.light': '浅色',
  'theme.dark': '深色',
  'theme.system': '系统',
  'theme.sakura': '樱花',

  // generic
  email: '电子邮箱',
  password: '密码',
  ok: '确定',
  cancel: '取消',
  retry: '重试',
  copy: '复制',
  empty: '(无项目)',
  loading: '加载中...',
  calculating: '计算中...',
  error: '错误',

  'in_development': '此页面正在开发中。',

  // errors
  'error.not_found': '未找到',
  'error.name_conflict': '名称冲突',
  'error.bad_param': '参数错误',
  'error.wrong_auth': '认证错误',
  'error.unauthorized': '未授权',
  'error.wrong_credentials': '凭据错误',
  'error.wrong_provider': '服务商错误',
  'error.insufficient_privileges': '权限不足',
  'error.not_empty': '非空',
  'error.limit_exceeded': '超出限制',
  'error.already_member': '已是成员',
  'error.not_finalized': '未完成',
  'error.already_finalized': '已完成',
  'error.unexpected_patch': '非预期的补丁',
  'error.timeout': '超时',
  'error.not_patch': '非补丁',
  'error.not_supported': '不支持',
  'error.unexpected_error': '非预期错误',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': '身份认证',
  'auth.dialog.please_select': '请选择您的账号服务商以登录。',
  'auth.dialog.redirecting_to': (provider) => `正在重定向至 ${provider}...`,
  'auth.dialog.remember_me': '记住我',
  'auth.dialog.log_in': '登录',
  'auth.dialog.back': '返回',
  'auth.dialog.progress_header': '正在认证...',
  'auth.dialog.error.header': '认证错误',
  'auth.dialog.error.auth_not_allowed': '用户已禁止使用此凭据进行认证。请使用其他凭据。',
  'auth.dialog.error.unknown': '无效的认证参数。请重试。',
  'auth.dialog.error.back': '返回',

  'user.profile': '个人资料',
  'user.logout': '退出登录',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': '页面未找到',
  'page_not_found.message': '此页面不存在。',
  'page_not_found.message2': '好吧，它其实算存在，但这里什么都没有。可能有以下原因：',
  'page_not_found.items': [
    '这里以前有东西，但现在已被删除。',
    '这里确实有东西，但您没有访问权限。',
    '或者只是有人在复制粘贴链接时不够小心。',
  ],

  'home': '首页',
  'home.header.hint': '面向独立开发者的云端工具',
  'home.description': 'Kavykhi.Cloud 是一个面向独立游戏的开发平台。我们支持可下载游戏和网页游戏、私有和公开构建版本、分支、团队等众多功能。',
  'home.auth': '登录或注册',
  'home.auth.hint': '创建新账号或登录现有账号',

  'projects': '项目',
  'projects.hint': '您正在参与的项目',
  'projects.project': (project) => `项目：${project}`,
  'projects.project.hint': '项目',
  'projects.no_projects': '您目前没有任何项目。',
  'projects.new': '创建项目',
  'projects.new_dialog.header': '新建项目',
  'projects.new_dialog.label': '项目名称',
  'projects.new_dialog.ok': '创建项目',
  'projects.store_page': '公开商店页面',
  'projects.description': '描述',
  'projects.branches': '分支',
  'projects.versions': '版本',
  'projects.packages': '包',
  'projects.management': '项目设置',
  'projects.management.breadcrumb': '设置',
  'projects.management.title': (projectTitle) => `${projectTitle} - 设置`,
  'projects.management.hint': '项目设置',
  'projects.management.users': '团队成员',
  'projects.management.users.empty': '暂无团队成员。',
  'projects.management.users.role.tester': '测试员',
  'projects.management.users.role.developer': '开发者',
  'projects.management.users.role.admin': '管理员',
  'projects.management.users.role.owner': '所有者',
  'projects.management.users.role.starred': '已星标',
  'projects.management.users.exile': '移出团队',
  'projects.management.users.exile.dialog.header': '移出团队',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>您确定要将 {userTitle} 从项目 {projectTitle} 中移出吗？</>,
  'projects.management.users.exile.dialog.ok': '移出团队',
  'projects.management.invites.one_time_invite': '一次性邀请链接',
  'projects.management.invites.one_time_invite.header': '一次性邀请链接',
  'projects.management.invites.one_time_invite.message': '一次性邀请链接：',
  'projects.management.invites.one_time_invite.note': '有效期 24 小时，仅可使用一次。',
  'projects.management.invites.new_dialog.header': '邀请链接',
  'projects.management.invites.new_dialog.expires': '过期时间：',
  'projects.management.invites.new_dialog.expires.indefinite': '(永不过期)',
  'projects.management.invites.new_dialog.approval.label': '用户加入项目：',
  'projects.management.invites.new_dialog.approval.not_approved': '需管理员批准',
  'projects.management.invites.new_dialog.approval.approved': '立即加入',
  'projects.management.invites.new_dialog.seats': '加入人数限制：',
  'projects.management.invites.new_dialog.seats.no_limit': '(无限制)',
  'projects.management.invites.new_dialog.ok': '创建邀请链接',
  'projects.management.deploy_sites': '部署站点',
  'projects.management.deploy_sites.empty': '未添加部署站点。',
  'projects.management.deploy_sites.add': '添加部署站点',
  'projects.management.deploy_sites.delete': '删除',
  'projects.management.deploy_sites.delete_dialog.header': '删除部署站点',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>您确定要删除 {provider} 的部署站点 {site} 吗？</>,
  'projects.management.deploy_sites.delete_dialog.ok': '删除部署站点',
  'projects.management.public_access': '公开访问',
  'projects.management.public_access.enable': '启用公开访问',
  'projects.management.public_access.enabled': <>公开访问：<strong>已允许</strong></>,
  'projects.management.public_access.enabled.note': '项目的名称和描述是公开的，任何标记为公开的分支也是公开的。',
  'projects.management.public_access.enable_dialog.header': '启用公开访问',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>您确定要允许公开访问项目 {projectTitle} 吗？<br /><br />这将使项目的基本信息在无需认证的情况下可见。您需要单独为希望公开的每个分支启用公开访问。</>,
  'projects.management.public_access.enable_dialog.ok': '启用公开访问',
  'projects.management.public_access.disable': '禁用公开访问',
  'projects.management.public_access.disabled': <>公开访问：<strong>未允许</strong></>,
  'projects.management.public_access.disabled.note': '该项目为私有。只有项目团队的成员才能访问。',
  'projects.management.public_access.disable_dialog.header': '禁用公开访问',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>您确定要禁用项目 {projectTitle} 的所有公开访问吗？</>,
  'projects.management.public_access.disable_dialog.ok': '禁用公开访问',
  'projects.management.public_access.branches': '公开分支',
  'projects.management.manage': '管理项目',
  'projects.rename': '重命名项目',
  'projects.rename_dialog.header': '重命名项目',
  'projects.rename_dialog.label': '项目名称：',
  'projects.rename_dialog.ok': '重命名项目',
  'projects.edit_description': '编辑项目描述',
  'projects.edit_description_dialog.header': '编辑项目描述',
  'projects.edit_description_dialog.label': '项目描述：',
  'projects.edit_description_dialog.ok': '编辑描述',
  'projects.leave': '离开项目',
  'projects.leave_dialog.header': '离开项目',
  'projects.leave_dialog.message': (projectTitle) => <>您确定要离开项目 {projectTitle} 吗？</>,
  'projects.leave_dialog.ok': '离开项目',
  'projects.delete': '删除项目',
  'projects.delete_dialog.header': '删除项目',
  'projects.delete_dialog.message': (projectTitle) => <>您确定要删除项目 {projectTitle} 吗？</>,
  'projects.delete_dialog.ok': '删除项目',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': '分支',
  'branches.no_branches': '该项目暂无分支',
  'branches.new': '创建分支',
  'branches.new_dialog.header': '新建分支',
  'branches.new_dialog.label': '分支名称',
  'branches.new_dialog.ok': '创建分支',
  'branches.current_version': (version) => <>当前版本：{version}</>,
  'branches.current_version.packages': '当前版本包',
  'branches.no_current_version': '无当前版本',
  'branches.publish_version.new': '发布新版本',
  'branches.publish_version.existing': '重新发布现有版本',
  'branches.version_history': '版本历史',
  'branches.version_history.empty': '该分支的版本历史为空。',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>当前分支版本保留时间：{quotaTime != null ? <>{quotaTime}</> : <>永久</>}。历史版本最多保留 {quotaNonCurrentTime}。每个分支总共最多保留 {plural(quotaCount, <>{quotaCountText} 个版本</>, <>{quotaCountText} 个版本</>)}。</>,
  'branches.manage': '管理分支',
  'branches.rename': '重命名分支',
  'branches.rename_dialog.header': '重命名分支',
  'branches.rename_dialog.label': '分支名称：',
  'branches.rename_dialog.ok': '重命名分支',
  'branches.delete': '删除分支',
  'branches.delete_dialog.header': '删除分支',
  'branches.delete_dialog.message': (branchTitle) => <>您确定要删除分支 {branchTitle} 吗？</>,
  'branches.delete_dialog.ok': '删除分支',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': '版本',
  'versions.current': '当前',
  'versions.previous': '历史',
  'versions.description': '描述',
  'versions.deploy_to_site.header': '发布到站点',
  'versions.deploy_to_site': '发布到站点',
  'versions.packages': '包',
  'versions.branches': '所在分支',
  'versions.branches.publish': '发布到分支',
  'versions.branches.empty': '该版本尚未在任何分支中发布。',
  'versions.new_dialog.header': '新建版本',
  'versions.new_dialog.label_title': '版本：',
  'versions.new_dialog.label_branch': '分支：',
  'versions.new_dialog.packages.header': '包',
  'versions.new_dialog.packages.empty': '未添加包。',
  'versions.new_dialog.packages.add': '添加包',
  'versions.new_dialog.packages.add_existing': '添加先前上传的包',
  'versions.new_dialog.packages.replace': '替换包',
  'versions.new_dialog.packages.edit': '编辑包',
  'versions.new_dialog.ok': '创建版本',
  'versions.manage': '管理版本',
  'versions.rename': '重命名版本',
  'versions.rename_dialog.header': '重命名版本',
  'versions.rename_dialog.label': '版本名称：',
  'versions.rename_dialog.ok': '重命名版本',
  'versions.edit_description': '编辑版本描述',
  'versions.edit_description_dialog.header': '编辑版本描述',
  'versions.edit_description_dialog.label': '版本描述：',
  'versions.edit_description_dialog.ok': '编辑描述',
  'versions.delete': '删除版本',
  'versions.delete_dialog.header': '删除版本',
  'versions.delete_dialog.message': (versionTitle) => <>您确定要删除版本 {versionTitle} 吗？</>,
  'versions.delete_dialog.ok': '删除版本',

  'versions.publish_dialog.header': '发布版本到分支',
  'versions.publish_dialog.message': (versionTitle) => <>选择要将版本 {versionTitle} 发布到的分支。</>,
  'versions.publish_dialog.no_branches': '项目中没有分支。',
  'versions.publish_dialog.ok': '发布版本',

  'versions.publish_existing_dialog.header': '重新发布版本',
  'versions.publish_existing_dialog.message': '最近版本：',
  'versions.publish_existing_dialog.no_versions': '项目中没有版本。',
  'versions.publish_existing_dialog.ok': '发布版本',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': '包',
  'packages.download_zip': '下载为 ZIP',
  'packages.download_torrent': '下载种子',
  'packages.total_size': (size) => <>总大小：{size}</>,
  'packages.manage': '管理包',
  'packages.rename': '重命名包',
  'packages.rename_dialog.header': '重命名包',
  'packages.rename_dialog.label': '包名称：',
  'packages.rename_dialog.ok': '重命名包',
  'packages.edit_tags': '编辑包标签',
  'packages.edit_tags_dialog.header': '编辑包标签',
  'packages.edit_tags_dialog.message': (packageTitle) => <>指定包 {packageTitle} 的标签：</>,
  'packages.edit_tags_dialog.ok': '设置包标签',
  'packages.entrypoint': (entrypoint) => <>启动文件：{entrypoint}</>,
  'packages.entrypoint.empty': '未设置启动文件。',
  'packages.delete': '删除包',
  'packages.delete_dialog.header': '删除包',
  'packages.delete_dialog.message': (packageTitle) => <>您确定要删除包 {packageTitle} 吗？该包将从所有已添加的版本中删除。</>,
  'packages.delete_dialog.ok': '删除包',

  'packages.new_dialog.header': '新建包',
  'packages.new_dialog.label_title': '标题：',
  'packages.new_dialog.title_placeholder': '(来自标签)',
  'packages.new_dialog.tags.header': '标签',
  'packages.new_dialog.files.header': '文件',
  'packages.new_dialog.total_size': (size, maximum) => <>总大小：{size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(最大 {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>新数据大小：{size}</>,
  'packages.new_dialog.checks.empty': '未添加文件。',
  'packages.new_dialog.checks.entrypoint.empty': '未设置启动文件。',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>启动文件 {entrypoint} 不存在；您是否忘记添加它？请指定一个现有的启动文件，或者您也可以不设置启动文件。</>,
  'packages.new_dialog.checks.entrypoint.missing.action': '取消设置启动文件',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>启动文件扩展名为 {fileExt}：建议添加 {tag} 标签。</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>添加 {tag} 标签</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>启动文件扩展名为 {fileExt}：添加 {tag} 标签以使该包可在浏览器中运行。</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>启动文件扩展名为 {fileExt}：这是否是个错误？通常这不是可以启动的文件类型。</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>启动文件扩展名为 {fileExt}：建议直接包含实际内容文件，而不是将其打包到归档文件中。</>,
  'packages.new_dialog.checks.entrypoint.executable': '启动文件未标记为可执行文件',
  'packages.new_dialog.checks.entrypoint.executable.action': '标记为可执行文件',
  'packages.new_dialog.checks.single_root_dir': '建议将文件直接放在根目录下，而不是在根目录下只包含单个文件夹。',
  'packages.new_dialog.checks.single_root_dir.action': '用文件夹内容替换文件夹',

  'packages.add_existing_dialog.header': '添加包',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `添加 ${plural(packagesCount, `${packagesCount} 个包`, `${packagesCount} 个包`)}` : '未选择包',
  'packages.add_existing_dialog.message': '最近上传的包：',
  'packages.add_existing_dialog.no_packages': '最近没有上传的包。',

  'packages.launch': '启动',

  'packages.install': '安装',
  'packages.install_dialog.header': '安装',
  'packages.install_dialog.workdir.label': '工作目录：',
  'packages.install_dialog.workdir.value.new': '(创建新目录)',
  'packages.install_dialog.workspace.label': '在此目录下创建文件夹：',
  'packages.install_dialog.workspace.placeholder': '(选择根文件夹)',
  'packages.install_dialog.ok': '安装',

  'packages.update': '更新',

  'packages.upload.status.existing': '来自上一个版本',
  'packages.upload.status.queued': '排队中',
  'packages.upload.status.packing': '打包中...',
  'packages.upload.status.creating': '创建中...',
  'packages.upload.status.create_retrying': '创建失败，正在等待并重试',
  'packages.upload.status.splitting': '拆分中...',
  'packages.upload.status.uploading': '上传中...',
  'packages.upload.status.finalizing': '正在完成...',
  'packages.upload.status.finalize_retrying': '完成失败，正在等待并重试',
  'packages.upload.status.resolving': '正在解析补丁...',
  'packages.upload.status.resolve_retrying': '解析补丁失败，正在等待并重试...',
  'packages.upload.status.done': '上传成功',
  'packages.upload.status.errored': '错误',

  'packages.upload.part.status.queued': '排队中',
  'packages.upload.part.status.hashing': '哈希计算中',
  'packages.upload.part.status.upload_queued': '上传排队中',
  'packages.upload.part.status.uploading': '上传中',
  'packages.upload.part.status.upload_retrying': '错误，正在重试上传',
  'packages.upload.part.status.upload_finalizing': '正在完成上传',
  'packages.upload.part.status.upload_errored': '错误',
  'packages.upload.part.status.done': '已上传',

  'packages.play': '在浏览器中运行',
  'packages.play.reset': '重置',
  'packages.play.fullscreen': '全屏',

  'deploy_sites.add_dialog.header': '添加部署站点',
  'deploy_sites.add_dialog.message': (projectTitle) => <>选择部署凭据并输入站点 URL，以将其保存为项目 {projectTitle} 的部署站点。</>,
  'deploy_sites.add_dialog.label_credential': '部署凭据：',
  'deploy_sites.add_dialog.select_credential': '选择凭据',
  'deploy_sites.add_dialog.select_credential.new': '添加新凭据...',
  'deploy_sites.add_dialog.label_select_site': '选择站点：',
  'deploy_sites.add_dialog.select_credential_first': '(请先选择凭据)',
  'deploy_sites.add_dialog.select_site': '(选择站点)',
  'deploy_sites.add_dialog.label_enter_site': '或输入站点 URL：',
  'deploy_sites.add_dialog.ok': '添加站点',

  'deploy_to_site_dialog.header': '发布到站点',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>选择要发布项目 {projectTitle} 的版本 {versionTitle} 的站点。</>,
  'deploy_to_site_dialog.label_site': '发布到站点：',
  'deploy_to_site_dialog.select_site': '选择站点',
  'deploy_to_site_dialog.select_site.new': '添加新部署站点...',
  'deploy_to_site_dialog.packages.message.itch': <>包将使用 <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a> 发布到 itch.io。频道名称派生自包标签。</>,
  'deploy_to_site_dialog.deploy': '发布',
  'deploy_to_site_dialog.close': '关闭',
  'deploy_to_site_dialog.error.no_packages': '没有可发布的包。',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>不能将多个包发布到单个频道中。当前已设置将 {plural(packagesCount, <>{packagesCountText} 个包</>, <>{packagesCountText} 个包</>)} 发布到频道 {channel}。</>,
  'deploy_to_site_dialog.job.queued': '排队中',
  'deploy_to_site_dialog.job.downloading': '下载中...',
  'deploy_to_site_dialog.job.unpacking': '解包中...',
  'deploy_to_site_dialog.job.uploading': '发布中...',
  'deploy_to_site_dialog.job.succeeded': '成功',
  'deploy_to_site_dialog.job.errored': '错误',

  'store': '商店',
  'store.hint': '公开项目',
  'store.project.hint': '商店项目页面',
  'store.project.owner': '开发者',
  'store.project.description': '描述',
  'store.project.star': '星标',
  'store.project.starred': '已星标',
  'store.project.content': '内容',
  'store.project.content.warning': '此内容由第三方开发者提供。',
  'store.project.branch_version': (branchTitle, versionTitle) => <>{branchTitle} 分支：版本 {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>发布时间：{branchVersionPublished}</>,

  'me': '个人资料',
  'me.hint': '个人资料设置和关联的凭据',
  'me.rename': '重命名个人资料',
  'me.rename_dialog.header': '重命名个人资料',
  'me.rename_dialog.label_title': '名称：',
  'me.rename_dialog.ok': '重命名个人资料',
  'me.credentials': '凭据',
  'me.credentials.hint.auth_allowed': '这些凭据中的任何一个都可以用于登录此账号。',
  'me.credentials.hint.auth_disallowed': '这些凭据已关联到您的账号，但不能用于登录。',
  'me.credentials.empty': '无凭据。',
  'me.credentials.empty.auth_allowed.warning': '您可能会被锁定在账号之外！您尚未关联任何可用于登录的凭据。请尽快关联一个可登录的凭据。',
  'me.credentials.profile_picture.alt': (provider) => `${dict[`auth.provider.${provider}`]} 头像`,
  'me.credentials.created': (created) => <>已于 {created} 添加</>,
  'me.credentials.last_used': (lastUsed) => <>上次使用于 {lastUsed}</>,
  'me.credential.unlink': '取消关联',
  'me.credential.allow_auth': '允许登录',
  'me.credential.disallow_auth': '禁止登录',
  'me.credential.display_publicly': '公开显示',
  'me.credential.dont_display_publicly': '不公开显示',
  'me.credential.link': '关联凭据',
  'me.credential.link_dialog.header': '关联凭据',
  'me.credential.link_dialog.message': '请选择要关联的账号服务商。',
  'me.credential.unlink_dialog.header': '取消关联凭据',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>您确定要从您的 Kavykhi.Cloud 账号中取消关联 {credentialProvider} 账号 {credentialTitle} 吗？</>,
  'me.credential.unlink_dialog.ok': '取消关联凭据',
  'me.sessions': '会话',
  'me.sessions.hint': '这是您的活动会话列表，包括您当前的浏览器。',
  'me.sessions.started': (started) => <>开始于 <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>活跃于 <span class="value">{lastAuth}</span></>,
  'me.sessions.current': '当前会话',
  'me.sessions.empty': '无会话。',
  'me.sessions.delete': '终止',
  'me.sessions.delete_dialog.header': '终止会话',
  'me.sessions.delete_dialog.message': '您确定要终止此会话吗？',
  'me.sessions.delete_dialog.ok': '终止会话',
  'me.api_tokens': 'API 令牌',
  'me.api_tokens.hint': '可以在此处创建 API 令牌以用于自动化。',
  'me.api_tokens.started': (started) => <>创建于 <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>过期时间 <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': '永不过期',
  'me.api_tokens.empty': '无 API 令牌。',
  'me.api_tokens.create': '生成 API 令牌',
  'me.api_tokens.create_dialog.header': '生成 API 令牌',
  'me.api_tokens.create_dialog.message': '生成的 API 令牌：',
  'me.api_tokens.create_dialog.note': '该令牌不会再次显示，请妥善保存。',
  'me.api_tokens.delete': '删除',
  'me.api_tokens.delete_dialog.header': '删除 API 令牌',
  'me.api_tokens.delete_dialog.message': '您确定要删除此令牌吗？',
  'me.api_tokens.delete_dialog.ok': '删除 API 令牌',
  'me.deploy_credentials': '部署凭据',
  'me.deploy_credentials.hint': '可以在此处添加用于部署到发布平台的凭据。',
  'me.deploy_credentials.empty': '未添加部署凭据。',
  'me.deploy_credential.add': '添加部署凭据',
  'me.deploy_credential.add_dialog.header': '添加部署凭据',
  'me.deploy_credential.add_dialog.label_site': '站点：',
  'me.deploy_credential.add_dialog.label_title': '备注：',
  'me.deploy_credential.add_dialog.label_key': '密钥：',
  'me.deploy_credential.add_dialog.default_title': (date) => `密钥 ${date}`,
  'me.deploy_credential.add_dialog.ok': '添加部署凭据',
  'me.deploy_credential.add_dialog.hint.itch': <>要生成 itch.io API 密钥，请转到您在 itch.io 上的 <a href="https://itch.io/user/settings/api-keys" target="_blank">个人资料设置</a>。您可以使用来源为 "web" 或 "wharf" 的现有 API 密钥。来源为 "Kavykhi.Cloud" 的 API 密钥将无法工作。</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>我们目前不支持添加 {credentialProvider} 凭据。</>,
  'me.deploy_credential.delete': '删除',
  'me.deploy_credential.delete_dialog.header': '删除部署凭据',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>您确定要删除 {credentialProvider} 的凭据 {credentialTitle} 吗？使用此凭据配置的任何部署站点也将从项目中移除。</>,
  'me.deploy_credential.delete_dialog.ok': '删除凭据',
  'me.public_profile': '公开个人资料',
  'me.public_profile.public_credentials': '公开凭据',
  'me.public_profile.public_credentials.hint': '选择要公开显示的凭据。',
  'me.manage': '管理账号',
  'me.delete': '删除账号',
  'me.delete.dialog.header': '删除账号',
  'me.delete.dialog.message': (userTitle) => <>您确定要永久删除您的 Kavykhi.Cloud 账号 {userTitle} 吗？</>,
  'me.delete.dialog.ok': '删除账号',

  'invite': '邀请',
  'invite.hint': '项目邀请',
  'invite.message.already_member': (projectTitle) => <>您已经是项目 {projectTitle} 的成员。</>,
  'invite.message.join': (projectTitle) => <>您已被邀请加入项目 {projectTitle}。</>,
  'invite.join': '加入项目',

  'local': '本地内容',
  'local.hint': '本地安装的内容',
  'local.workdirs': '已安装的包',
  'local.workdirs.empty': '无已安装的包。',
  'local.workdir.action.launch': '启动',
  'local.workdir.action.repair': '修复',
  'local.workdir.action.delete': '卸载',
  'local.workdir.delete_dialog.header': '卸载包',
  'local.workdir.delete_dialog.message': (packageTitle) => <>您确定要从您的设备上卸载包 {packageTitle} 吗？</>,
  'local.workdir.delete_dialog.ok': '卸载',
  'local.workspaces': '根文件夹',
  'local.app_not_detected.message': '未检测到 Kavykhi.Cloud 本地应用。请使用下方链接下载并安装。如果您已经安装，请确保它正在运行。',

  'local_app.detected': '本地内容',

  'error_dialog.header': '错误',
  'error_dialog.messageFunc': (e) => `错误：${dict[`error.${e}`] ?? e}。`,

  'upload_box.choose_files': '选择文件',
  'upload_box.choose_directories': '选择文件夹',
  'upload_box.add.progress_dialog.header': '正在添加文件',
  'upload_box.add.progress_dialog.message': '正在处理文件...',
  'upload_box.delete': (itemsCount) => `删除 ${plural(itemsCount, `${itemsCount} 个项目`, `${itemsCount} 个项目`)}`,
  'upload_box.start_upload': '开始上传',
  'upload_box.drop_area.message': '将文件和文件夹拖放到此处',
  'upload_box.drop_area.box_dropping_message': '拖放到此处以放入根目录',
  'upload_box.entry.explode_folder': '用文件夹内容替换文件夹',
  'upload_box.entry.set_entrypoint': '设置启动文件',
  'upload_box.entry.mark_executable': '标记为可执行文件',
  'upload_box.entry.unmark_executable': '取消可执行标记',
  'upload_box.entry.remove': '移除',

  'package.tags.empty': '(无标签)',
  'package.tag.os': '操作系统',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': '架构',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': '位数',
  'package.tag.bits:64': '64 位',
  'package.tag.bits:32': '32 位',
  'package.tag.packaging': '打包格式',
  'package.tag.packaging:installer': '安装程序',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': '组件',
  'package.tag.component:client': '客户端',
  'package.tag.component:server': '服务端',
  'package.tag.runtime': '运行环境',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Linux 发行版',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': '文档',
  'docs.page_no_language': '此语言版本不可用',
  'docs.page_no_language.message': '此文档的其他可用版本：',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': '举报内容',
  'report_content.dialog.header': '举报内容',
  'report_content.dialog.link': '通过电子邮件发送举报',
  'report_content.dialog.message': (email, link) => <>请点击链接发送您的举报：<br /><br />{link}<br /><br />或者手动发送电子邮件至 {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
